/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2024, Zumper
 */

import type { ResidentQuotes } from '@zcode/state-type'

export const MAX_QUOTES_TO_SHOW = 50

export const RESIDENT_QUOTES_SLICE_NAME = 'residentQuotes'

export const RESIDENT_QUOTES_INITIAL_STATE: ResidentQuotes = {
  data: null,
  groupId: null,
}
